import React, { useState } from 'react'
import { objectToOptions, arrayToOptions } from 'Utilities/selectOptions'
import { uniqBy, map, filter } from 'lodash'
import { Tabs, Tab } from 'react-bootstrap'

import { defaultFilters, SoftwareFilters } from './Filters'
import ActiveDirectoryTable from './ActiveDirectoryTable'
import RDSTable from './RDSTable'

const CloudCoreSoftwareTerminalServersReport = ({ terminalServers }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const filterOptions = {
    customers: uniqBy(map(terminalServers, vm => ({ value: vm.viaje_client_id, label: vm.customer_name })), 'label')
  }

  return (
    <Tabs id="cloudcore-terminal-server-report" activeKey={filters.currentTab} onSelect={currentTab => changeFilters({ ...filters, currentTab })}>
      <Tab eventKey='ActiveDirectory' title='Active Directory'>
        {/* <Filters {...{ filters, changeFilters, filterOptions }} /> */}

        <ActiveDirectoryTable {...{ terminalServers: filter(terminalServers, ['ad_server', 1]) }} />
      </Tab>

      <Tab eventKey='RDS' title='RDS'>
        {/* <Filters {...{ filters, changeFilters, filterOptions }} /> */}

        <RDSTable {...{ terminalServers }} />
      </Tab>
    </Tabs>
  )
}

export default CloudCoreSoftwareTerminalServersReport
